import { observer } from 'mobx-react-lite'
import { usePendingJobId } from '@/features/jobs/details/job-navigation-hooks'
import { type JobItemViewModel } from './JobItemViewModel'
import { JobItem } from '@/features/jobs/details/components/JobList/JobItem'
import { Avatar } from '@/components/Avatar'

export interface JobItemContainerProps {
  vm: JobItemViewModel
}

export const JobItemContainer = observer(function JobItemContainer({
  vm,
}: JobItemContainerProps) {
  const pendingJobId = usePendingJobId()

  return (
    <JobItem
      to={vm.href}
      isActive={pendingJobId ? pendingJobId === vm.job.id : vm.isActive}
      visual={
        <Avatar
          exclaim={!!vm.latestOpenTicket}
          size={32}
          subject={vm.collaborators}
        />
      }
      lastActivity={vm.lastActivity}
      unreadCount={vm.unreadCount}
      workspaceName={
        vm.isWorkspaceInfoRelevant ? vm.job.workspace.name : undefined
      }
      jobName={vm.jobName}
      collaboratorNames={vm.collaboratorNames}
    />
  )
})
